module.exports = __webpack_public_path__ + "img/yqss_fx.8759a767.svg";